import React, { useState, useMemo } from 'react';
import { 
  CssBaseline, 
  ThemeProvider, 
  PaletteMode 
} from '@mui/material';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { getTheme } from './theme';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Team from './components/Team';
import Announcement from './components/Announcement';
import Footer from './components/Footer';
import SignIn from './components/SignIn';
import Dashboard from './components/Dashboard';

// HomePage component to group all the main page components
const HomePage = () => (
  <>
    <Hero />
    <Features />
    <Pricing />
    <Team />
    <Announcement />
  </>
);

function App() {
  // 使用 localStorage 來保存用戶的主題偏好
  const [mode, setMode] = useState<PaletteMode>(() => {
    const savedMode = localStorage.getItem('themeMode');
    return (savedMode as PaletteMode) || 'light';
  });

  // 切換主題模式
  const toggleColorMode = () => {
    const newMode = mode === 'light' ? 'dark' : 'light';
    setMode(newMode);
    localStorage.setItem('themeMode', newMode);
  };

  // 根據當前模式創建主題
  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Header toggleColorMode={toggleColorMode} />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/sign_in" element={<SignIn />} />
            <Route path="/dashboard" element={<Dashboard />} />
            {/* Redirect any unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
